/*
 * @Author: cc
 * @Date: 2020-01-10 11:30:32
 * @LastEditTime : 2020-01-10 12:01:17
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\networkResource\classifiedResource\digitalnews\resDigitalnewsRouter.js
 * @Description:
 */
'use strict';
angular.module('resDigitalnewsRouter', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.classifiedresource.digital.resource', {
                url: '/resource?acode&fcode&media_id&param_data&medianame',
                views: {
                    'networksource@front.networksource.classifiedresource.digital': {
                        templateUrl: './networkResource/classifiedResource/digitalnews/digital_tpl.html',
                        controller: 'resDigitalCtrl',
                    },
                },
            })
            .state('front.networksource.classifiedresource.digital.preview', {
                url: '/preview?nodeid&nodename&isShowPreview&parentid',
                views: {
                    'networksource@front.networksource.classifiedresource.digital': {
                        templateUrl: './networkResource/classifiedResource/digitalnews/preview_tpl.html',
                        controller: 'resCenDigitalPreviewCtrl',
                    },
                },
            })
            .state('front.networksource.classifiedresource.digital.quickpreview', {
                url: '/quickpreview?acode&fcode&media_id&param_data&guid',
                views: {
                    'networksource@front.networksource.classifiedresource.digital': {
                        templateUrl: './networkResource/classifiedResource/digitalnews/quickPreview/main_tpl.html',
                        controller: 'digitalQuickPreviewCtrl',
                    },
                },
            });
    },
]);
